import React from 'react';
import { UserContext } from '../contexts';

export const useUser = () => React.useContext(UserContext);
